import { useContext } from "react"
import { AppointmentContext } from "../contexts/AppointmentContext";

export const useAppointment = () => {
  const context = useContext(AppointmentContext);
  return context;
}